import React from 'react';
import { GetStaticProps, GetStaticPaths } from 'next';
import { BlogLayout } from '../../components/blog/BlogLayout';
import { BlogSEO } from '../../components/blog/BlogSEO';
import { BlogPostComponent } from '../../components/blog/BlogPost';
import { getAllPosts, getPostBySlug, getRelatedPosts, BlogPost } from '../../lib/blog';

interface BlogPostPageProps {
  post: BlogPost;
  relatedPosts: BlogPost[];
}

const BlogPostPage: React.FC<BlogPostPageProps> = ({ post, relatedPosts }) => {
  const breadcrumbItems = [
    { label: post.title }
  ];

  return (
    <>
      <BlogSEO post={post} />

      <div className="bg-[#0F1624] text-white w-full min-h-screen">
        <BlogLayout breadcrumbItems={breadcrumbItems}>
          <BlogPostComponent post={post} relatedPosts={relatedPosts} />
        </BlogLayout>
      </div>
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  const posts = getAllPosts();
  const paths = posts.map((post) => ({
    params: { slug: post.slug },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug as string;
  const post = getPostBySlug(slug);

  if (!post) {
    return {
      notFound: true,
    };
  }

  const relatedPosts = getRelatedPosts(slug, 3);

  return {
    props: {
      post,
      relatedPosts,
    },
  };
};

export default BlogPostPage;
